import { numberWithSpaces } from '../../../utils/math';

export function decisionLabel(label: string, value: number) {
  return `
  ${label}\u00A0: ${numberWithSpaces(value)}\u00A0décision${
    value > 1 ? 's référencées' : ''
  }${value === 1 ? ' référencée' : ''}`;
}

export function percentLabel(label: string, value: number) {
  return `
  ${label}\u00A0: ${numberWithSpaces(value)}\u00A0%`;
}
